import {
  profiles,
  studiesIds,
  unauthorizedStudyStatus,
} from "../../modules/constants";
import GSD33AdminLanding from "../../pages/GSD3/Admin/Landing";
import GSD3ParticipantLanding from "../../pages/GSD3/Participant/Landing";
import GSD3Stats from "../../pages/GSD3/Stats";
import GSD3Favorites from "../../pages/GSD3/Participant/Favorites";
import GSD3ChangeRequests from "../../pages/GSD3/ChangeRequests";
import DataComments from "../../pages/GSD3/Admin/DataComments";
import GSD3Management from "../../pages/GSD3/Admin/Management";

export default [
  {
    path: "/study",
    genericRoute: true,
    authorize: [
      profiles.participant,
      profiles.studyAdmin,
      profiles.pi,
      profiles.dietitian,
      profiles.siteCoordinator,
      profiles.medicalMonitor,
      profiles.sponsor,
      profiles.siteMonitor,
    ],
    study: studiesIds.gsdiii,
    redirectNonAuthorized: "/unauthorized",
  },
  {
    path: "/participant",
    component: GSD3ParticipantLanding,
    authorize: [profiles.participant],
    unauthorizedStudyStatus: unauthorizedStudyStatus.gsdiii,
    study: studiesIds.gsdiii,
    redirectNonAuthorized: "/unauthorized",
    redirectNonStudyEnrolled: "/accessdenied",
    fullpage: false,
    withNavbar: true,
    withSidebar: true,
  },
  {
    path: "/admin",
    component: GSD33AdminLanding,
    authorize: [
      profiles.studyAdmin,
      profiles.pi,
      profiles.dietitian,
      profiles.siteCoordinator,
      profiles.medicalMonitor,
      profiles.sponsor,
      profiles.siteMonitor,
    ],
    study: studiesIds.gsdiii,
    redirectNonAuthorized: "/unauthorized",
    fullpage: false,
    withNavbar: true,
    withSidebar: true,
  },
  {
    path: "/stats/:participantId?",
    component: GSD3Stats,
    authorize: [
      profiles.participant,
      profiles.dietitian,
      profiles.sponsor,
      profiles.siteCoordinator,
      profiles.pi,
      profiles.medicalMonitor,
      profiles.studyAdmin,
      profiles.siteMonitor,
    ],
    unauthorizedStudyStatus: unauthorizedStudyStatus.gsdiii,
    redirectNonStudyEnrolled: "/accessdenied",
    study: studiesIds.gsdiii,
    redirectNonAuthorized: "/unauthorized",
    fullpage: false,
    withNavbar: true,
    withSidebar: true,
  },
  {
    path: "/favorites",
    component: GSD3Favorites,
    authorize: [profiles.participant],
    study: studiesIds.gsdiii,
    redirectNonAuthorized: "/unauthorized",
    unauthorizedStudyStatus: unauthorizedStudyStatus.gsdiii,
    redirectNonStudyEnrolled: "/accessdenied",
    fullpage: false,
    withNavbar: true,
    withSidebar: true,
  },
  {
    path: "/change-requests",
    component: GSD3ChangeRequests,
    authorize: [
      profiles.dietitian,
      profiles.sponsor,
      profiles.siteCoordinator,
      profiles.pi,
      profiles.medicalMonitor,
      profiles.studyAdmin,
      profiles.siteMonitor,
    ],
    study: studiesIds.gsdiii,
    redirectNonAuthorized: "/unauthorized",
    fullpage: false,
    withNavbar: true,
    withSidebar: true,
  },
  {
    path: "/data-comments",
    component: DataComments,
    authorize: [profiles.pi, profiles.medicalMonitor],
    study: studiesIds.gsdiii,
    redirectNonAuthorized: "/unauthorized",
    fullpage: false,
    withNavbar: true,
    withSidebar: true,
  },
  {
    path: "/management",
    component: GSD3Management,
    authorize: [profiles.itAdmin],
    redirectNonAuthorized: "/unauthorized",
    withNavbar: true,
    withSidebar: false,
  },
];
